import { Link, useParams, useSearchParams } from "react-router-dom";
import { ErrorIcon } from "../../components/ui/Icons";
import { Page } from "../../components/ui/Page";
import { usePanelPath } from "../../routing";

export function ErrorPage({ hideNav }: { hideNav?: boolean }) {
  const [searchParams] = useSearchParams();
  const params = useParams();
  const panelPath = usePanelPath();
  const error = searchParams.get("error");
  return (
    <Page>
      <div className="completion-wrap">
        <div className="screenout-icon">
          <ErrorIcon />
        </div>
        <h2
          style={{
            color: "var(--red)",
            fontFamily: "var(--font-h)",
            fontSize: 26,
            fontWeight: 600,
          }}
        >
          Hmm, something went wrong
        </h2>
        <p
          style={{
            color: "var(--sand)",
            fontSize: 14,
            lineHeight: 1.6,
            margin: "8px 0 22px",
          }}
        >
          It looks like there was a problem with your completion of the task. If
          the problem persists, please reach out to support.
        </p>
        {error && (
          <pre
            style={{
              color: "var(--red)",
              fontSize: 13,
              lineHeight: 1.4,
              marginBottom: 20,
            }}
          >
            <code>{error}</code>
          </pre>
        )}
        {!hideNav && (
          <>
            <Link
              className="btn btn-accent btn-full"
              style={{ marginBottom: 10 }}
              to={panelPath("/tasks")}
            >
              View other tasks
            </Link>
            <Link className="btn btn-outline btn-full" to={panelPath("/")}>
              Back to dashboard
            </Link>
          </>
        )}
      </div>
    </Page>
  );
}
